import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 100);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 h-12 w-full bg-forest transition-shadow duration-200 ease-out ${scrolled ? 'shadow-[0_6px_18px_rgba(10,26,16,0.35)]' : 'shadow-none'}`} data-id="element-169" data-mp="2yxhs3924hon8">
      <div className="mx-auto flex h-full max-w-7xl items-center justify-between gap-3 px-3 sm:px-6" data-id="element-170" data-mp="2p63ooq71w4ot">
        <p className="hidden items-center gap-2 text-[13px] font-semibold text-cream/90 lg:flex" data-id="element-171" data-mp="2k8bvlsuo6cj1">
          <FlameIcon className="h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-172" data-mp="2f6mgo24btepo" />
          PRECIO DE LANZAMIENTO — Solo por tiempo limitado
        </p>

        <div className="flex items-center gap-2" data-id="element-173" data-mp="1rwsnljcddz06">
          <span className="hidden text-[11px] font-semibold uppercase tracking-widest text-cream/60 sm:inline" data-id="element-174" data-mp="1rvzn304085qh">
            Termina en
          </span>
          <CountdownTimer data-id="element-175" data-mp="1hzwcr6z010sg" />
        </div>

        <button type="button" className="whitespace-nowrap rounded-full bg-coral px-3.5 py-1.5 text-[12px] font-bold text-white transition-transform duration-150 ease-out hover:scale-[1.03] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:px-5 sm:text-[13px]" data-id="element-176" data-mp="1i0xzw9tahdqj">
          PRECIO DE LANZAMIENTO $9.99 USD
        </button>
      </div>
    </header>;
}